import axios from 'axios';
import _merge from 'lodash/merge';

import user from './../extra/user';

/**
 * @param {string} apiUrl - API endpoint
 * @param {import('axios').AxiosRequestConfig & {
 *  isPublic: boolean,
 * }} options - Request options
 */
export default function get(apiUrl = '', options = {}) {
  if (!apiUrl) {
    throw new Error('API Endpoint was not provided');
  }

  const token = user.getToken();
  const { isPublic, ...config } = options;

  const endpoint = `${process.env.REACT_APP_BASE_URL}${apiUrl}`;
  const axiosConfig = _merge(
    { headers: isPublic ? {} : { Authorization: `Token ${token}` } },
    config
  );

  return axios.get(endpoint, axiosConfig);
}
